<template>
	<div>
		<el-container >
			<el-aside width="250px">
				<DeptTree @getTreeData="deptTreeNodeClick"/>
			</el-aside>

			<el-container>
				<el-header >
					<el-form :inline="true" >
						<el-form-item>
							<el-input
									v-model="searchForm.code"
									placeholder="人员编号"
									clearable
									style="display: block; width: 180px;"
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input
									v-model="searchForm.name"
									placeholder="姓名"
									clearable
									style="display: block; width: 180px;"
							>
							</el-input>
						</el-form-item>
						<el-form-item width="60%">
							<el-input
									v-model="searchForm.card"
									placeholder="卡号"
									clearable
									style="display: block; width: 150px;"
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-button @click="getPersonList">搜索</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="dialogVisible = true">新增</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="selectMenu({name: 'PersonImport', title: '人员导入'})">导入</el-button>
						</el-form-item>

						<!-- <el-form-item>
							<el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item> -->
					</el-form>
				</el-header>

				<el-main>
					<el-table
							ref="multipleTable"
							:data="tableData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: -20px;"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handleSelectionChange">

						<el-table-column
								type="selection"
								width="55">
						</el-table-column>

						<el-table-column
								prop="personNo"
								label="人员编号"
								show-overflow-tooltip
								width="130">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								show-overflow-tooltip
								width="120">
						</el-table-column>

						<el-table-column
								prop="personSex"
								label="性别"
								width="80">
								<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
								<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
								<el-tag size="small" v-else type="danger">未知</el-tag>
							</template>
						</el-table-column>

						<el-table-column
								prop="identityName"
								label="身份"
								show-overflow-tooltip
								width="100">
						</el-table-column>

						<el-table-column
								prop="fullName"
								label="部门"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="idNo"
								label="证件号码"
								width="120"
								show-overflow-tooltip>
						</el-table-column>

						<!-- <el-table-column
								prop="cardSerial"
								label="卡号"
								show-overflow-tooltip>
						</el-table-column> -->
						
						<el-table-column
								prop="endDate"
								label="有效日期"
								show-overflow-tooltip
								width="120">
						</el-table-column>
						
						<el-table-column
								prop="guardianName"
								label="监护人"
								width="120"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="guardianPhone"
								label="监护人电话"
								width="120"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="card"
								label="卡号">
							<template slot-scope="scope">
								<el-tag size="small" type="info" v-for="item in scope.row.baseCards">{{item.cardSerial}}</el-tag>
							</template>

						</el-table-column>

						<el-table-column
								prop="fingerFlag"
								label="指纹"
								width="70">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.fingerFlag === 0" type="danger">无</el-tag>
								<el-tag size="small" v-else type="success">有</el-tag>
							</template>

						</el-table-column>

						<el-table-column
								prop="statusFlag"
								label="状态"
								width="80">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.statusFlag === 1" type="success">正常</el-tag>
								<el-tag size="small" v-else-if="scope.row.statusFlag === 0" type="danger">禁用</el-tag>
							</template>

						</el-table-column>

						<el-table-column
								prop="icon"
								label="操作"
								width="140">

							<template slot-scope="scope">

								<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
								<el-button type="text" @click="editPersonCard(scope.row)">卡片</el-button>
								<el-button type="text" @click="editPersonFinger(scope.row)">指纹</el-button>
								
								<!--<el-divider direction="vertical"></el-divider>

								 <template>
									<el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template> -->

							</template>
						</el-table-column>

					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100, 500, 1000]"
							:current-page="current"
							:page-size="size"
							:total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
				title="人员信息编辑"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-container>
					<el-aside width="100%">
						<el-form-item label="人员编号" prop="personNo" label-width="100px">
							<el-input v-model="editForm.personNo" autocomplete="off"></el-input>
						</el-form-item>

						<el-form-item label="姓名" prop="personName" label-width="100px" style="margin-top:-5px">
							<el-input v-model="editForm.personName" autocomplete="off"></el-input>
						</el-form-item>

						<el-form-item label="性别" prop="personSex" label-width="100px" style="margin-top:-5px">
							<el-radio-group v-model="editForm.personSex">
								<el-radio :label=1>男</el-radio>
								<el-radio :label=0>女</el-radio>
							</el-radio-group>
						</el-form-item>	
						
						<el-form-item label="身份" prop="identityId" label-width="100px" style="margin-top:-5px">
							<el-select v-model="editForm.identityId" placeholder="请选择身份">
								<el-option v-for="identity in identityList" :label="identity.identityName" :value="identity.id" :key="identity.id"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="有效期" prop="endDate" label-width="100px" style="margin-top:-5px">
							<el-date-picker v-model="editForm.endDate" type="date" placeholder="选择日期"></el-date-picker>
						</el-form-item>
					</el-aside>
					<!-- <el-main>
						<el-form-item prop="photoUrl" label-width="30px">
							<el-image
								style="width: 130px; height: 160px"
								:src="editForm.photoUrl">
							</el-image>
						</el-form-item>

						<el-form-item label-width="30px">
							<el-button size="small" @click="clearPhoto('editForm')">清空</el-button>
							<el-button type="primary" size="small" @click="clearPhoto('editForm')">选择</el-button>
						</el-form-item>
					</el-main> -->
				</el-container>

				

				<el-form-item label="部门" prop="deptId" label-width="100px" style="margin-top:-5px">
					<el-select v-model="editForm.deptId" placeholder="请选择部门" >
						<el-option 
						:value="editForm.deptId"
              			:label="editForm.fullName"
						style="width: 460px;height: 200px;overflow: auto;background-color: #fff;">
							<DeptTree  @getTreeData="deptSelectNodeClick"/>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="证件号码" prop="idNo" label-width="100px" style="margin-top:-5px">
					<el-input v-model="editForm.idNo" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="监护人" prop="guardianName" label-width="100px" style="margin-top:-5px">
					<el-input v-model="editForm.guardianName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="监护人电话" prop="guardianPhone" label-width="100px" style="margin-top:-5px">
					<el-input v-model="editForm.guardianPhone" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="个人密码" prop="personPwd" label-width="100px" style="margin-top:-5px">
					<el-input v-model="editForm.personPwd" autocomplete="off" show-password></el-input>
				</el-form-item>

				<!-- <el-form-item label="状态" prop="statusFlag" label-width="100px">
					<el-radio-group v-model="editForm.statusFlag">
						<el-radio :label=0>禁用</el-radio>
						<el-radio :label=1>正常</el-radio>
					</el-radio-group>
				</el-form-item> -->

				<!-- <el-form-item>
					<el-button type="primary" @click="submitForm('editForm')">保存</el-button>
					<el-button @click="resetForm('editForm')">重置</el-button>
				</el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
				:title="selectedPersonInfo"
				:visible.sync="cardDialogVisible"
				width="1000px"
				:before-close="handleCardFormClose"
				:close-on-click-modal="false">

			<el-form :model="cardForm" ref="cardForm" label-width="100px" class="demo-editForm">

				<el-container style="margin-top: -20px;">
					<el-main>
						<el-form :inline="true" style="margin-top: -20px;">
							<el-form-item>
								<el-input
										v-model="newCardSerail"
										ref="cardSerail"
										placeholder="卡号"
										clearable
								>
								</el-input>
							</el-form-item>
							
							<el-form-item>
								<el-button type="primary" @click="bindCardHandle">绑定</el-button>
							</el-form-item>
						</el-form>
						<el-table
							ref="cardTable"
							:data="cardData"
							tooltip-effect="dark"
							style="width: 100%; height: 370px; margin-top: -20px;"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '2px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe>

							<el-table-column
									type="selection"
									width="55">
							</el-table-column>

							<el-table-column
									prop="cardSerial"
									label="卡号"
									width="100">
							</el-table-column>

							<el-table-column
									prop="regDate"
									label="绑定时间"
									width="180">
							</el-table-column>

							<el-table-column
								prop="statusId"
								label="状态"
								width="80">
								<template slot-scope="scope">
								<el-tag size="small" v-if="(scope.row.statusId === 0)" type="success">在用</el-tag>
								<el-tag size="small" v-else-if="(scope.row.statusId === 1)" type="danger">已解绑</el-tag>
							</template>
						</el-table-column>

							<el-table-column
									prop="statusTime"
									label="状态变动时间"
									width="180"
									show-overflow-tooltip>
							</el-table-column>

							<el-table-column
									prop="endDate"
									label="有效期"
									width="120"
									show-overflow-tooltip>
							</el-table-column>

							<el-table-column
								prop="icon"
								label="操作"
								width="120">

							<template slot-scope="scope">
								 <template>
									<el-popconfirm title="确定要解绑该卡吗？" @confirm="unBindCardHandle(scope.row.id)">
										<el-button type="text" slot="reference">解绑</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column>
						</el-table>
						
					</el-main>
				</el-container>
				<!-- <el-form-item>
					<el-button type="primary" @click="saveWhiteListHandle">保存</el-button>
					<el-button @click="resetForm('editForm')">取消</el-button>
				</el-form-item> -->
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<!-- <el-button @click="resetCardForm('cardForm')">取 消</el-button> -->
				<el-button type="primary" @click="resetCardForm('cardForm')">关 闭</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
				:title="selectedPersonInfo"
				:visible.sync="fingerDialogVisible"
				width="900px"
				:before-close="handleFingerFormClose"
				:close-on-click-modal="false">

			<el-form :model="fingerForm" ref="fingerForm" label-width="100px" class="demo-editForm">
				<Finger ref="childFinger" :collectPersonId="bindFingerPersonId"/>
			</el-form>
			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<el-button type="primary" @click="handleFingerFormClose('fingerForm')">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    import DeptTree from "./DeptTree.vue"
	import Finger from "./Finger.vue"
	export default {
		name: "Person",
		components:{DeptTree, Finger},
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},
				cardDialogVisible: false,
				cardForm: {},

				fingerDialogVisible: false,
				fingerForm: {},

				tableData: [],
				cardData: [],

				selectedIdentityId:'',
				identityList:[],

				editFormRules: {
					personNo: [
						{required: true, message: '请输入人员号', trigger: 'blur'}
					],
					personName: [
						{required: true, message: '请输入姓名', trigger: 'blur'}
					],
					personSex: [
						{required: true, message: '请选择性别', trigger: 'blur'}
					],
					identityId: [
						{required: true, message: '请选择身份', trigger: 'blur'}
					],
					deptId: [
						{required: true, message: '请选择部门', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'personName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				selectedPersonInfo: '',
				newCardSerail: '',
				bindCardPersonId: '',
				bindFingerPersonId: ''
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			}
		},
		created() {
			this.getPersonList()
			this.getIdentityList()

			this.$axios.get('/base/person/list').then(res => {
				this.permTreeData = res.data.data
			})

			// this.$nextTick(() => {
			// 	this.getFingerList
			// })
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getPersonList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getPersonList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			resetCardForm() {
				this.cardDialogVisible = false
				this.cardForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			handleCardFormClose() {
				this.resetForm('cardForm')
			},
			handleFingerFormClose() {
				this.fingerDialogVisible = false
			},
			deptSelectNodeClick(deptdata) {
				this.$set(this.editForm, "deptId", deptdata.id);
				this.$set(this.editForm, "fullName", deptdata.fullName);
				// console.log(deptdata);
			},
			deptTreeNodeClick(deptdata) {
				this.treeSelectDeptId = deptdata.id;
				this.getPersonList();
			},

			getPersonList() {
				this.$axios.get("/base/person/list", {
					params: {
						code: this.searchForm.code,
						name: this.searchForm.name,
						card: this.searchForm.card,
						deptId: this.treeSelectDeptId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getIdentityList() {
				this.$axios.get("/base/identity/list", {
					// params: {
					// 	name: this.searchForm.name,
					// 	current: this.current,
					// 	size: this.size
					// }
				}).then(res => {
					this.identityList = res.data.data.records
				})
			},

			getCardList() {
				this.$axios.get("/base/card/list", {
					params: {
						personId: this.bindCardPersonId,
						current: 1,
						size: 100
					}
				}).then(res => {
					this.cardData = res.data.data.records
				})
			},
			getFingerList() {

				setTimeout(() => {
					this.$refs.childFinger.getFingerList();
				}, 10)

				// this.$refs.childFinger.getFingerList();
				// this.$refs.childFinger.$emit("getPersonFingerList")    //子组件$on中的名字
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/base/person/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose:() => {
										this.getPersonList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/base/person/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			editPersonCard(row) {
				this.bindCardPersonId = row.id;
				this.selectedPersonInfo = row.personNo + "(" + row.personName + ") 卡片绑定";
				this.newCardSerail = ''
				this.getCardList()
				this.cardDialogVisible = true
				this.$nextTick(() => {
					this.$refs.cardSerail.focus();
				})
			},
			editPersonFinger(row) {
				this.bindFingerPersonId = row.id;
				this.selectedPersonInfo = row.personNo + "(" + row.personName + ") 指纹采集";
				this.fingerDialogVisible = true
				this.getFingerList()
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/base/person/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose:() => {
							this.getPersonList()
						}
					});
				})
			},
			bindCardHandle() {
				this.$axios.post('/base/card/bind/' + this.bindCardPersonId, this.newCardSerail)
							.then(res => {
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose:() => {
										this.getCardList()
									}
								});
							})
			},
			unBindCardHandle(id) {
				this.$axios.post("/base/card/unbind", id).then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose:() => {
							this.getCardList()
						}
					});
				})
			},
			clearPhoto(formName) {
				formName.photoUrl = ""
			},
			selectMenu(item) {
				this.$store.commit("addTab", item)
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 96%;
	}

</style>